import React from 'react'

export const getMenuItems = () => {
    const userId = localStorage.getItem('id') || 1;
    return {
        "admin": [
            {
                title: 'Admin', icon: <i className="pe-7s-home pe-lg"></i>, path: '/dashboard/default', type: 'sub', active: true, bookmark: true, children: [
                    { title: 'Generale', type: 'sub', active: true, },
                    { title: 'Dashboard', type: 'link', path: '/dashboard/default', },
                    { title: 'Gestione', type: 'sub-header' },
                    { title: 'Utenti', type: 'link', path: '/users', active: false },
                    { title: 'Gruppi', type: 'link', path: '/groups', },
                    { title: 'Sessioni', type: 'sub-header' },
                    { title: 'Ricerca', type: 'link', path: '/sessions', active: false },
                    { title: 'Aggiungi sessione', type: 'link', path: '/sessions/add', active: false },
                    { title: 'Settings', type: 'sub-header' },
                    { title: 'Profilo', type: 'link', path: `/profilo?id=${userId}`, active: false },
                ],
            },
        ],
        "groupadmin": [
            {
                title: 'GroupAdmin', icon: <i className="pe-7s-home pe-lg"></i>, path: '/dashboard/default', type: 'sub', active: true, bookmark: true, children: [
                    { title: 'Generale', type: 'sub', active: true, },
                    { title: 'Dashboard', type: 'link', path: '/dashboard/default', },
                    { title: 'Gestione', type: 'sub-header' },
                    { title: 'Utenti', type: 'link', path: '/users', active: false },
                    { title: 'Sessioni', type: 'sub-header' },
                    { title: 'Ricerca', type: 'link', path: '/sessions', active: false },
                    { title: 'Settings', type: 'sub-header' },
                    { title: 'Profilo', type: 'link', path: `/profilo?id=${userId}`, active: false },
                ],
            },
        ],
        "user": [
            {
                title: 'User', icon: <i className="pe-7s-home pe-lg"></i>, path: '/dashboard/default', type: 'sub', active: true, bookmark: true, children: [
                    { title: 'Sessioni', type: 'sub-header' },
                    { title: 'Ricerca', type: 'link', path: '/sessions', active: false },
                    { title: 'Settings', type: 'sub-header' },
                    { title: 'Profilo', type: 'link', path: `/profilo?id=${userId}`, active: false },
                ],
            },
        ],
        "anonymous": [
            {
                title: 'Sessioni', icon: <i className="pe-7s-video"></i>, path: '/sessions', type: 'sub', active: false, children: [
                    { title: 'Ricerca', type: 'link', path: '/sessions', active: false },
                ],
            },
        ]
    };
};
